module.exports = "<app-npssurvey-list></app-npssurvey-list>\n"